import { Store as BLStore } from '@accedo/general-store';
import { PagePersist } from '##/services/store/types';

/**
 * In memory store. Any data is lost on page refresh.
 * Be careful not to misuse this store as it will not automatically release data back to memory.
 * (see services/cache if that is needed).
 */
class Store<T = unknown> extends BLStore {
  setByKey(key: string, value: unknown): void {
    this.$set({ [key]: value });
  }

  getByKey<V>(key: string): V {
    return this.$get()[key];
  }

  deleteByKey(key: string): void {
    const data = this.$get();
    delete data[key];
    this.$set(data);
  }

  get(): T {
    return super.$get();
  }

  set(data: Partial<T>): void {
    super.$set(data);
  }
}

export const config = new Store<Record<string, unknown>>();
export const persist = new Store<PagePersist>();

if (window.nimble && window.nimble.appConfig) {
  config.set(window.nimble.appConfig);
  window.nimble.appConfig = undefined;
}
let script = document.getElementById('appConfig');
if (script && script.parentElement) {
  script.parentElement.removeChild(script);
  script.remove();
  script = null;
}
